import api from "@/api";
import { IGame, IGameTemplateDto, IGameTemplateMixDto, IRoom, ThemeType } from "@/types/api-types";
import { DeepPartial } from "@/types/typescript-types";

export function getGames(
  page: number = 1,
  limit: number | null = 10,
  sortBy: string = "_id",
  sortOrder: number = 1,
  searchQuery: string,
  status: string,
  client: string,
  industry: string
) {
  const query = new URLSearchParams({
    sortOrder: sortOrder.toString(),
    sortBy,
  });

  if (limit != null) {
    query.append("page", ((page - 1) * limit).toString());
    query.append("limit", limit.toString());
  }

  if (searchQuery.length > 0) {
    query.append("query", searchQuery);
  }
  if (status.length > 0) {
    query.append("status", status);
  }
  if (client.length > 0) {
    query.append("client", client);
  }
  if (industry.length > 0) {
    query.append("industry", industry);
  }

  return api.get(`/games${query.toString().length > 0 ? "?" + query.toString() : ""}`);
}

export function getGame(gameId: string) {
  return api.get(`/games/${gameId}`);
}

export function createGame(game: DeepPartial<IGame>) {
  return api.post(`/games`, game);
}

export function updateGame(gameId: string, game: IGame) {
  return api.put(`/games/${gameId}`, game);
}

export function deleteGame(gameId: string) {
  return api.delete(`/games/${gameId}`);
}

export function duplicateGame(game: IGame) {
  return api.post(`/games`, {
    ...game,
    _id: undefined,
    status: "draft",
  });
}

export function createRoom(gameId: string, room: IRoom) {
  return api.post(`/games/${gameId}/rooms`, room);
}

export function updateRoom(gameId: string, roomId: string, room: IRoom) {
  return api.put(`/games/${gameId}/rooms/${roomId}`, room);
}

export function deleteRoom(gameId: string, roomId: string) {
  return api.delete(`/games/${gameId}/rooms/${roomId}`);
}

export function getClientList() {
  return api.get(`/games/clients`);
}

export function getGameThemesDetails(themes: ThemeType[]) {
  const urlParams = new URLSearchParams();
  themes.forEach((t) => urlParams.append("themes", t));
  return api.get<IGame[]>(`/games/game-themes-details?${urlParams.toString()}`);
}

export function createGameFromTemplate(creationParams: IGameTemplateDto) {
  return api.post(`/games/createGameFromTemplate`, creationParams);
}

export function createGameFromCustomMixTemplate(creationParams: IGameTemplateMixDto) {
  return api.post(`/games/createGameFromCustomMixTemplate`, creationParams);
}
